import { type ReactNode } from "react";
import { ArrowRight, Circle, CircleAlert, CircleCheck, CircleHelp } from "lucide-react";
import { reportStageLabels, type StaffReportStage } from "@/api/staff_reports";
import { Badge } from "@/components/ui/badge";

const blueStageClassName = "bg-[#E6EEFB] text-[#254B83] dark:bg-[#20344F] dark:text-[#B8D1F5]";
const stageBadges: Record<StaffReportStage, { className: string; icon: ReactNode }> = {
  preparation: { className: "bg-muted text-[#66696A] dark:text-muted-foreground", icon: null },
  reading_files: {
    className: blueStageClassName,
    icon: <Circle className="h-2 w-2 shrink-0 fill-current" aria-hidden="true" />,
  },
  questions: {
    className: "bg-[#FCE8CF] text-[#784507] dark:bg-[#49351C] dark:text-[#F9D6A7]",
    icon: <CircleHelp className="h-3 w-3 shrink-0" aria-hidden="true" />,
  },
  ready_to_write: {
    className: blueStageClassName,
    icon: <ArrowRight className="h-3 w-3 shrink-0" aria-hidden="true" />,
  },
  writing: {
    className: blueStageClassName,
    icon: <Circle className="h-2 w-2 shrink-0 fill-current" aria-hidden="true" />,
  },
  ready_to_review: {
    className: "bg-[#E2F4D6] text-[#315923] dark:bg-[#283E20] dark:text-[#CBEBB5]",
    icon: <CircleCheck className="h-3 w-3 shrink-0" aria-hidden="true" />,
  },
  needs_attention: {
    className: "bg-[#F9E2E2] text-[#8F3030] dark:bg-[#4A2929] dark:text-[#EFADAD]",
    icon: <CircleAlert className="h-3 w-3 shrink-0" aria-hidden="true" />,
  },
};

export function StaffReportStageBadge({ stage }: { stage: StaffReportStage }) {
  return (
    <Badge
      variant="outline"
      className={`gap-1.5 whitespace-nowrap border-transparent font-normal ${stageBadges[stage].className}`}
    >
      {stageBadges[stage].icon}
      {reportStageLabels[stage]}
    </Badge>
  );
}
